import React from 'react'

const DIET_CLASS_BY_LABEL = {
  Vegan: 'vegan',
  Vegetarisch: 'vegetarian'
} as const

const DietIcon: React.FC<{ diet?: string; decorative?: boolean }> = ({ diet, decorative }) => {
  if (!diet) {
    return null
  }

  const dietClass = DIET_CLASS_BY_LABEL[diet as keyof typeof DIET_CLASS_BY_LABEL]

  if (!dietClass) {
    return null
  }

  return (
    <span
      className={`diet-icon ${dietClass}`}
      title={decorative ? undefined : diet}
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : diet}
      role={decorative ? undefined : 'img'}
    />
  )
}

export { DietIcon }
